const sortAlphabetically = (a, b) => {
  const A = a.name?.toUpperCase();
  const B = b.name?.toUpperCase();
  return A < B ? -1 : A > B ? 1 : 0;
};
export default sortAlphabetically;
